export default __webpack_public_path__ + "static/media/correct-icon.db6f2015.svg";